import { FeatureCollection } from '/entities/Marker';

export const initialGeojson: FeatureCollection = {
  type: 'FeatureCollection',
  features: [],
};
